export default __webpack_public_path__ + "static/media/b-14.5e2ca62b.png";